export interface ChangelogEntry {
  id: string;
  version: string;
  title: string;
  description: string;
  category: 'feature' | 'improvement' | 'bugfix' | 'security' | 'breaking';
  is_published: boolean;
  published_at: string | null;
  author_email: string;
  created_at: string;
  updated_at: string;
}

export interface EntryForm {
  version: string;
  title: string;
  description: string;
  category: ChangelogEntry['category'];
  is_published: boolean;
}

export const CATEGORIES: { value: ChangelogEntry['category']; label: string; icon: string; color: string }[] = [
  { value: 'feature', label: 'New Feature', icon: '✨', color: '#10b981' },
  { value: 'improvement', label: 'Improvement', icon: '🔧', color: '#3b82f6' },
  { value: 'bugfix', label: 'Bug Fix', icon: '🐛', color: '#f59e0b' },
  { value: 'security', label: 'Security', icon: '🔒', color: '#8b5cf6' },
  { value: 'breaking', label: 'Removed', icon: '🗑️', color: '#ef4444' },
];

// Manual entries default to Draft; published rows feed the public changelog.
// The existing admin RPC contract has no platform/release_key fields.
export const EMPTY_FORM: EntryForm = {
  version: '',
  title: '',
  description: '',
  category: 'feature',
  is_published: false,
};
